import {NameGenerator} from '@domain/custom-settings/name-generator';
import {PathLabelType} from '@domain/production-schedule/path-label-type.enum';
import {AssertionUtils} from '@vdw/angular-component-library';

export class PathLabelInformationForPart {
  private _nameGenerator: NameGenerator;
  private _pathLabelType: PathLabelType;

  public constructor(nameGenerator: NameGenerator, pathLabelType: PathLabelType) {
    this._nameGenerator = nameGenerator;
    this._pathLabelType = pathLabelType;
  }

  public get nameGenerator(): NameGenerator {
    return this._nameGenerator;
  }

  public set nameGenerator(value: NameGenerator) {
    this._nameGenerator = value;
  }

  public get pathLabelType(): PathLabelType {
    return this._pathLabelType;
  }

  public set pathLabelType(value: PathLabelType) {
    this._pathLabelType = value;
  }

  public static fromJSON(pathLabelInformationForPartJSON: any): PathLabelInformationForPart {
    if (AssertionUtils.isNullOrUndefined(pathLabelInformationForPartJSON)) {
      return null;
    }

    return new PathLabelInformationForPart(
      AssertionUtils.isNullOrUndefined(pathLabelInformationForPartJSON.nameGenerator) ? null : NameGenerator.fromJSON(pathLabelInformationForPartJSON.nameGenerator),
      pathLabelInformationForPartJSON.pathLabelType
    );
  }

  public toJSON(): JSON {
    return {
      nameGenerator: this._nameGenerator?.toJSON(),
      pathLabelType: this._pathLabelType
    } as any as JSON;
  }

  public isText(): boolean {
    return this._pathLabelType === PathLabelType.TEXT;
  }
}
